module.exports = __webpack_public_path__ + "static/media/capa.b8e7967f.jpg";